import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    position: 'absolute',
    right: 0,
    top: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '30px',
    background: "#f7f8fc",
    borderRadius: '16px',
    padding: '6px 7px',
    zIndex: 4,
  },
  addedAt: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.grey.grey800,
    marginLeft: '2px',
    marginRight: '5px',
    lineHeight: '130%',
  },
  date: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.grey.grey800,
    lineHeight: '130%',

  }

}));

export default useStyles;
